<template>
	<v-layout column class="pt-3">
 	<v-layout row align-center>
 	<v-flex class="subheading pl-4"> Search Results </v-flex> 
 	<v-flex shrink class="pr-5 ">
 		<v-select v-model="chartRoomProperty" 
 			:items="chartChoices" 

 						>
 		</v-select>
 	</v-flex>
 	</v-layout>
	<GChart class="pt-5" 
		    type="PieChart"
		    :data="chartData(chartRoomProperty)"
		    :options="chartOptions"/>
	</v-layout>
	</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { GChart } from 'vue-google-charts'

export default {
data () {
	return {
		chartRoomProperty: 'typeName',
		chartChoices: [ { text: 'Type', value: 'typeName'},
						{ text: 'Classification', value: 'classification'},
						{ text: 'Department', value: 'deptName'},
						{ text: 'Condition', value: 'condition'},
						{ text: 'Utilization', value: 'utilization'},
						{ text: 'Suitability', value: 'suitability'},
		 			  ],
		//chartData: [ [ 'Type', 'Percentage' ], [ 'Office', 30 ], [ 'Lab' ,60 ], [ 'Conference', 10 ] ],
    	chartOptions: {
	        chart: {
	          title: 'Unique Visitors',
	          subtitle: 'Date, Visitors',			          
	        },
	        chartArea:{left:0,top:0, right:80, width: "100%"}
	    } 
	}
},

components: { GChart, },

computed: {
	...mapState({   	searchResults: state => state.search.searchResults,
				}),
	
},

methods : {
	...mapMutations([ 	'setBuildings',
					]),

	chartData(roomProperty) {
		//Get Unique List of Legend Items
		let chartData = []

		if (!this.searchResults) { return }

		this.searchResults.sites.forEach((site) => {
			site.buildings.forEach((bldg) => {
				bldg.floors.forEach((floor) =>{
					floor.rooms.forEach((room) => {
						if (room[roomProperty] == null) { room[roomProperty] = "Not Evaluated"}
						// Add Label to the label array
						if (!chartData.find((legendItem) => legendItem.label == room[roomProperty] )) {  // Enforce Unique
						chartData.push({ 'label': room[roomProperty] })
					}
					})
				})
			})
		})
			
		//For each legend item, crawl through all rooms for matches.  Build Array of these rooms.
		let rooms = []
		chartData.forEach((legendItem) => {	
			rooms = []		
			this.searchResults.sites.forEach((site) => {
				site.buildings.forEach((bldg) => {
					bldg.floors.forEach((floor) =>{
						floor.rooms.forEach((room) => {
							if (room[roomProperty] == legendItem.label) { rooms.push(room) }
						})
					})
				})
			})		

			//Sum area for each array of rooms
			let area = 0			
			rooms.forEach((room) => { area += room.area })
			legendItem.area = area			
		})

		// Sort Array on Area
		chartData.sort(function(a,b) {return b.area - a.area});

		// Return chartData
		let cDataNew = [[ 'Type', 'Percentage' ]]
		chartData.forEach((legendItem) => { cDataNew.push([legendItem.label, legendItem.area]) })
		console.log("chartData", cDataNew)
		return cDataNew

	},
},
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/search/PieCharts.vue